import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBettingCenterConfig() {
    return {
        palette: {
            [PALETTE_IDS.BET_RECEIPT]: {
                BET_RECEIPT_BET_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                BET_RECEIPT_NUMBER_TEXT: COLOR.BRAND.FOREGROUND7,
                BET_RECEIPT_DEVICE_ID_TEXT: COLOR.BRAND.FOREGROUND7,
                BET_RECEIPT_TYPE_TEXT: COLOR.BRAND.FOREGROUND7,
            },
            [PALETTE_IDS.BETTING_CENTER]: {
                BETTING_CENTER_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                BETTING_CENTER_TAB_BUTTON_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_MEDIUM,
                },
                BETTING_CENTER_CONTENT_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                BETTING_CENTER_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
            },
            [PALETTE_IDS.BETSLIP]: {
                BETSLIP_ODDS_DROPDOWN_HIGHLIGHT_LABEL: COLOR.BRAND.FOREGROUND6,
                BETSLIP_TEASERS_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,

                BETSLIP_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,

                BETSLIP_BET_HIGHLIGHT_INDICATOR_COLOR: COLOR.SEMANTIC.WARNING1,

                BETSLIP_BB_BET_ICON_COLOR: COLOR.BRAND.ACCENT3,

                BETSLIP_REMOVE_ALL_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND5,
                        fontSize: FONT.SIZE_SMALL,
                    },
                },

                BETSLIP_FREE_BETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,

                // had to make primary dropdowns look like secondary according to Zeplin
                BETSLIP_BET_MARKETS_DROPDOWN: {
                    PRIMARY_DROPDOWN_BG: 'none',
                    PRIMARY_DROPDOWN_TEXT: COLOR.BRAND.FOREGROUND1,
                    PRIMARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                },

                BETSLIP_TEASERS_DROPDOWN: {
                    PRIMARY_DROPDOWN_BG: 'none',
                    PRIMARY_DROPDOWN_TEXT: COLOR.BRAND.FOREGROUND1,
                    PRIMARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                },

                BETSLIP_FREE_BETS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'capitalize',
                },

                BETSLIP_SETTINGS_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
                BETSLIP_SETTINGS_BUTTON_DOT_NOTIFICATION: {
                    DOT_COLOR: COLOR.BRAND.ACCENT1,
                },

                BETSLIP_SETTINGS_POPOVER: {
                    POPOVER_BG: COLOR.BRAND.BACKGROUND4,
                },

                BETSLIP_BB_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,

                // Sliding betslip
                SLIDING_BETSLIP_BUTTON_BASE_TEXT: COLOR.BRAND.FOREGROUND6,
                SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_BG: COLOR.BRAND.CTA1,
                SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_TEXT: COLOR.BRAND.FOREGROUND6,
                SLIDING_BETSLIP_BUTTON_SUCCESS_BG: COLOR.BRAND.CTA1,
                SLIDING_BETSLIP_BUTTON_SUCCESS_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                SLIDING_BETSLIP_BUTTON_OVERASK_BG: COLOR.BRAND.CTA1,
                SLIDING_BETSLIP_BUTTON_OVERASK_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                SLIDING_BETSLIP_BUTTON_FREEBETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                SLIDING_BETSLIP_BUTTON_FREEBETS_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.NUMERIC_KEYPAD]: {
                KEYPAD_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,
                KEYPAD_COMPACT_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
                KEYPAD_INCREASE_BUTTON_BG: COLOR.BRAND.BACKGROUND3,
                KEYPAD_BUTTON: {
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                    TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND7,
                    TOGGLE_BUTTON_TEXT: COLOR.BRAND.FOREGROUND1,
                },
            },
            [PALETTE_IDS.YOUR_BETS]: {
                OPEN_BET_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND1,
                },
                OPEN_BET_RESULT_TEXT: COLOR.BRAND.ACCENT3,
                OPEN_BET_LIVE_EVENT_SCOREBOARD: {
                    MINI_SCOREBOARD_SCORE_COUNT_TEXT: COLOR.BRAND.ACCENT3,
                },
            },
            [PALETTE_IDS.OVERASK]: {
                OVERASK_TIMER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_MEDIUM,
                },
                OVERASK_BET_OFFER_BG: COLOR.BRAND.BACKGROUND7,
                OVERASK_BET_OFFER_STATUS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_LARGE,
                },
                OVERASK_BET_OFFER_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    textTransform: 'capitalize',
                },
                OVERASK_BET_OFFER_HEADER_CHECK_BUTTON_BG: COLOR.BRAND.BACKGROUND3,
                OVERASK_BET_OFFER_HEADER_CHECK_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND3,
                OVERASK_BET_OFFER_HEADER_CHECK_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.QUICK_BETSLIP]: {
                QUICK_BETSLIP_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
            },
        },
    };
}
